import React from 'react';
import { WrapperNeedHelpStyled } from './Styled';

interface WrapperNeedHelpProps {
  children: JSX.Element;
  padding?: number;
  background?: boolean;
  widthMargin?: number;
}

const WrapperNeedHelp = (props: WrapperNeedHelpProps) => {
  const { widthMargin = 0, background = true, children, padding = 0 } = props;

  return (
    <WrapperNeedHelpStyled widthMargin={widthMargin} background={background} padding={padding}>
      {children}
    </WrapperNeedHelpStyled>
  );
};

WrapperNeedHelp.defaultProps = {};

export default WrapperNeedHelp;
export { WrapperNeedHelp };
